import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { LIFERAY_WEB_CONSTANT } from '../../../utils/liferay.constant';
import { IDashboardDiscloser } from '../../../interfaces/IJob';
import { Subject, takeUntil } from 'rxjs';
import { LiferayService } from '../../../services/liferay/liferay.service';
import { Ga4Service } from '../../../services/ga4/ga4.service';
import { IWebContant } from '../../../services/liferay/liferay.interface';
import { 
  DOWNLOAD_CLAIM_INSTRUCTIONS_LOCKSMITH,
  HANDYMAN_FEATURES_BENEFITS_CA_VIEW_PDF,
  HANDYMAN_FEATURES_BENEFITS_OTHER_STATES_VIEW_PDF,
  MADE_CC_FEATURES_AND_BENEFITS_VIEW_PDF,
  WHOLESALE_CLUB_FEATURES_BENEFITS_CA_VIEW_PDF,
  WHOLESALE_CLUB_FEATURES_BENEFITS_OTHER_STATES_VIEW_PDF,
  PERKS_BENEFITS_PAGE
} from '../../../services/ga4/ga4.constant';
import { 
  MADE_CC_FEATURES_BENEFITS,
  HANDYMAN_FEATURES_BENEFITS_CA,
  HANDYMAN_FEATURES_BENEFITS_OTHER_STATES,
  WHOLESALE_CLUB_FEATURES_BENEFITS_CA,
  WHOLESALE_CLUB_FEATURES_BENEFITS_OTHER_STATES,
  LOCKSMITH_FEATURES_BENEFITS
} from '../../../utils/constants';
import { FEATURES_AND_BENEFITS_CONTENT } from './features-and-benefits.constant';

@Component({
  selector: 'app-features-and-benefits',
  templateUrl: './features-and-benefits.component.html',
  styleUrl: './features-and-benefits.component.scss'
})
export class FeaturesAndBenefitsComponent implements OnInit, OnDestroy {
  @Input() type: string = '';
  @Input() pageLocation: string = '';
  content: { title: string, subTitle?: string, description: string, instructions?: string[] } | null = null;
  cleaner$ = new Subject<void>();
  liferayContent: IDashboardDiscloser | null = null;
  locksmithFeaturesBenefits = LOCKSMITH_FEATURES_BENEFITS;
  handymanFeatures: string[] = [
    HANDYMAN_FEATURES_BENEFITS_CA,
    HANDYMAN_FEATURES_BENEFITS_OTHER_STATES
  ];

  get isFullWidthCard(): boolean {
    return this.pageLocation !== PERKS_BENEFITS_PAGE;
  }

  constructor(private liferayService: LiferayService, private ga4Service: Ga4Service) { }

  ngOnInit(): void {
    this.content = FEATURES_AND_BENEFITS_CONTENT[this.type] || null;
    this.getFeaturesBenefitsPdfFromLiferay();
  }

  getFeaturesBenefitsPdfFromLiferay(): void {
    const perksBenefitsContent = LIFERAY_WEB_CONSTANT.perks_benefits_content;
    this.liferayService.getWebContent<IDashboardDiscloser[]>(perksBenefitsContent.type, perksBenefitsContent.id)
      .pipe(takeUntil(this.cleaner$)).subscribe({
        next: (response: IWebContant<IDashboardDiscloser[]>) => {
          if (!response || !response.value || response.value.length === 0) { return; }
          const content = response.value.find((content) => content.headingText === this.type);
          this.liferayContent = content || null;
        }
      });
  }

  openFeaturesBenefitsPdf(): void {
    const pdfUrl = this.liferayContent?.linkLabels[0]?.linkUrl;
    const buttonName: { [key: string]: string } = {
      [MADE_CC_FEATURES_BENEFITS]: MADE_CC_FEATURES_AND_BENEFITS_VIEW_PDF,
      [HANDYMAN_FEATURES_BENEFITS_CA]: HANDYMAN_FEATURES_BENEFITS_CA_VIEW_PDF,
      [HANDYMAN_FEATURES_BENEFITS_OTHER_STATES]: HANDYMAN_FEATURES_BENEFITS_OTHER_STATES_VIEW_PDF,
      [WHOLESALE_CLUB_FEATURES_BENEFITS_CA]: WHOLESALE_CLUB_FEATURES_BENEFITS_CA_VIEW_PDF,
      [WHOLESALE_CLUB_FEATURES_BENEFITS_OTHER_STATES]: WHOLESALE_CLUB_FEATURES_BENEFITS_OTHER_STATES_VIEW_PDF,
      [LOCKSMITH_FEATURES_BENEFITS]: DOWNLOAD_CLAIM_INSTRUCTIONS_LOCKSMITH
    }
    if (pdfUrl) {
      this.ga4Service.buttonClickEvent(this.pageLocation, buttonName[this.type] || '');
      window.open(pdfUrl, '_blank', 'noopener,noreferrer');
    }
  }

  ngOnDestroy(): void {
    this.cleaner$.next();
    this.cleaner$.complete();
  }
}
